export var occupationType = [
    { display: "Private Sector", value: "2" },
    { display: "Public Sector", value: "1" },
    { display: "Government Sector", value: "3" },
    { display: "X-Not Categorized", value: "96" },
    { display: "Professional", value: "5" },
    { display: "Retired", value: "7" },
    { display: "Housewife", value: "8" },
    { display: "Students", value: "9" },
    { display: "B-Business", value: "4" },
    { display: "O-Others(Please specify)", value: "99" },
];
export var residentialStatus = [
    { display: "Resident Individual", value: "R" },
    { display: "Non Resident Individual", value: "N" },
    { display: "Foreign National", value: "P" },
    { display: "Person Of Indian Origin", value: "O" },
];
export var ICKYCFileUpload;
(function (ICKYCFileUpload) {
    ICKYCFileUpload["FILE_passport"] = "FILE_passport";
    ICKYCFileUpload["FILE_pan"] = "FILE_pan";
    ICKYCFileUpload["FILE_Address_Proof"] = "FILE_Address_Proof";
})(ICKYCFileUpload || (ICKYCFileUpload = {}));
export var radioTrueFalseData = [
    { value: "Y", display: "Yes" },
    { value: "N", display: "No" },
];
export var CKYCFormData = {
    FatherName: "",
    MotherName: "",
    ResidentStatus: "",
    OccupationType: "",
    Occupation: "",
    address: "",
    PinCode: "",
    City: "",
    District: "",
    State: "",
    Country: "",
    FILE_passport: null,
    FILE_pan: null,
    FILE_Address_Proof: null,
};
export var CKYCinitResetFile = {
    passportReset: false,
    panReset: false,
    addressReset: false,
};
export var keysNotCompulsoryCKYCForm = [
    "MotherName",
    "District",
    "FILE_passport",
    "FILE_pan",
    "FILE_Address_Proof",
];
